import { render, staticRenderFns } from "./PickupDetailsStep.vue?vue&type=template&id=6207bb6a"
import script from "./PickupDetailsStep.vue?vue&type=script&lang=js"
export * from "./PickupDetailsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports